import React, { FC, MouseEventHandler } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import classnames from 'classnames';
import AlertBellIcon from 'dibs-icons/exports/AlertBell';
import styles from './Notifications-style.scss';
import { useUID } from 'dibs-uid';

type Props = {
    onClick: MouseEventHandler;
    onMouseEnter: MouseEventHandler;
    hasUnread?: boolean;
    isOpen: boolean;
};
const messages = defineMessages({
    label: {
        id: 'dbl.Header.NotificationsIcon.label',
        defaultMessage: 'Notifications',
    },
    description: {
        id: 'dbl.Header.NotificationsIcon.description',
        defaultMessage: 'Unread messages',
    },
});
const NotificationsIcon: FC<Props> = ({ onClick, isOpen, onMouseEnter, hasUnread = false }) => {
    const dataTn = `notifications-link${hasUnread ? '-unread' : ''}`;
    const uid = useUID() || undefined;
    const intl = useIntl();
    return (
        <button
            aria-label={intl.formatMessage(messages.label)}
            aria-describedby={hasUnread ? uid : undefined}
            aria-expanded={isOpen}
            aria-haspopup="true"
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            data-tn={dataTn}
            className={classnames(styles.icon, {
                [styles.hasUnread]: hasUnread,
            })}
        >
            {hasUnread && uid && (
                <span id={uid} className={styles.hidden}>
                    {intl.formatMessage(messages.description)}
                </span>
            )}
            <AlertBellIcon />
        </button>
    );
};

export default NotificationsIcon;
